export const fontWeights = {
  regular: 400,
  medium: 500,
  semiBold:600,
  bold: 700,
};

export const fontSizes = {
  verySmall: "8px",
  small: "10px",
  caption: "12px",
  button: "14px",
  smallBody: "14px",
  body: "16px",
  smallTitle: "18px",
  title: "20px",
  h5: "23px",
  h4: "26px",
  h3: "30px",
  h2: "35px",
  h1: "40px",
};
